import IncidentService from '../services/IncidentService';

export default class IncidentController {
  constructor({ repository, studentService, inventoryService, auditLogger }) {
    this.incidentService = new IncidentService(repository, studentService, inventoryService, auditLogger);
    this.listeners = new Set();
  }

  subscribe(listener) {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  }

  notify() {
    this.listeners.forEach((listener) => listener());
  }

  listIncidents() {
    return this.incidentService.list();
  }

  getIncident(id) {
    return this.incidentService.getById(id);
  }

  createIncident(data, user) {
    const incident = this.incidentService.create(data, user);
    this.notify();
    return incident;
  }

  updateIncident(id, data, user) {
    const incident = this.incidentService.update(id, data, user);
    this.notify();
    return incident;
  }

  closeIncident(id, user) {
    const incident = this.incidentService.close(id, user);
    this.notify();
    return incident;
  }

  listByStudent(studentId) {
    return this.incidentService.listByStudent(studentId);
  }

  listByInventoryItem(itemId) {
    return this.incidentService.listByInventoryItem(itemId);
  }

  seedFromLegacyReports(students, user) {
    this.incidentService.seedFromLegacyReports(students, user);
    this.notify();
  }
}
